<template>
  <div>
    <van-nav-bar
      title="等待配送"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <div v-for="item in sendorders" style="box-shadow: 5px -5px -5px grey;border: 1px solid #DCDFE6;margin-top: 10px;background-color: #fafafa;padding-top: 15px;padding-left: 10px;line-height: 25px;font-size: 14px;" @click="todetail(item.id)">
      <van-row>
        <van-col :span="14" >ID：{{item.sendbh}}
          <van-tag type="primary">等待配送</van-tag></van-col>
        <van-col :span="9" :offset="1">配送方式：{{item.send_type}}</van-col>
      </van-row>
      <van-row>
        <van-col :span="14">客户：{{item.clientname}}</van-col>
        <van-col :span="9" :offset="1">销售：{{item.salername}}</van-col>
      </van-row>
      <van-row>
        <van-col :span="24" >地址：{{item.address}}</van-col>
      </van-row>
      <van-row>
        <van-col :span="24" >备注：{{item.beizhu}}</van-col>
      </van-row>
   <!-- <van-col :span="9" :offset="1">配送方式：{{item.send_type}}</van-col> -->
    </div>



  </div>
</template>

<script>
  import * as Api from './api.js'
  export default {
    name: 'getmyorder',
    data () {
      return {
        value:'',
        sendorders:[],



      }
    },
    created() {
      this.$store.dispatch('getlocaluserinfo').then(res=>{
        this.getorder()
      })

    },
    methods:{
      getorder(){
        let query = {
          ordering:'-id',
          limit:999,
          status:1
        }
        Api.getsendorders(query).then(res=>{
          console.log(res)
          this.sendorders = res.data.data
        })
      },
      onClickLeft(){
        this.$router.push({path:'/'})
      },
      todetail(id){
        this.$router.push({path:'/cangkuviews/sendorderdetail',query:{id:id}})
      }

    }
  }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/cangkuviews/sendorder/index.vue